import { defineStore } from 'pinia'
import { ref, type Ref } from 'vue'
import { i18n, SupportedLocales, DefaultLocale, type SupportedLocale } from '@/i18n'

const LOCALE_KEY = 'locale'

/** Locale state — simplified vs. admin (no PrimeVue coupling). */
export const useLocaleStore = defineStore('locale', () => {
  const locale = ref<SupportedLocale>(
    (localStorage.getItem(LOCALE_KEY) as SupportedLocale) || DefaultLocale
  )

  function setLocale(next: SupportedLocale) {
    if (!SupportedLocales.includes(next)) return
    locale.value = next
    ;(i18n.global.locale as unknown as Ref<SupportedLocale>).value = next
    localStorage.setItem(LOCALE_KEY, next)
    document.documentElement.lang = next
  }

  function toggleLocale() {
    const i = SupportedLocales.indexOf(locale.value)
    const next = SupportedLocales[(i + 1) % SupportedLocales.length]
    if (next) setLocale(next)
  }

  function initialize() {
    document.documentElement.lang = locale.value
  }

  return { locale, supportedLocales: SupportedLocales, setLocale, toggleLocale, initialize }
})
